var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SOUND_WAVE",
    "data-name": "SOUND WAVE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.579,
    height: 57.207,
    viewBox: "0 0 86.579 57.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(35.899 17.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M215.173,189.02a2.879,2.879,0,0,0-2.88,2.88v16.893a2.88,2.88,0,1,0,5.759,0V191.9A2.88,2.88,0,0,0,215.173,189.02Z",
    transform: "translate(-212.293 -189.02)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(26.972 8.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M162.383,136.231a2.879,2.879,0,0,0-2.88,2.88v34.748a2.88,2.88,0,1,0,5.759,0V139.11A2.879,2.879,0,0,0,162.383,136.231Z",
    transform: "translate(-159.503 -136.231)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(17.949 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M109.026,86.847a2.879,2.879,0,0,0-2.88,2.88v51.448a2.88,2.88,0,1,0,5.759,0V89.727A2.879,2.879,0,0,0,109.026,86.847Z",
    transform: "translate(-106.146 -86.847)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(9.023 8.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M56.237,136.231a2.879,2.879,0,0,0-2.88,2.88v34.748a2.88,2.88,0,1,0,5.759,0V139.11A2.879,2.879,0,0,0,56.237,136.231Z",
    transform: "translate(-53.357 -136.231)",
    fill: "#fff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(0 16.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M2.88,185.614A2.879,2.879,0,0,0,0,188.494v18.045a2.88,2.88,0,0,0,5.759,0V188.494A2.879,2.879,0,0,0,2.88,185.614Z",
    transform: "translate(0 -185.614)",
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(62.87 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M374.676,86.847a2.879,2.879,0,0,0-2.88,2.88v51.448a2.88,2.88,0,1,0,5.759,0V89.727A2.879,2.879,0,0,0,374.676,86.847Z",
    transform: "translate(-371.796 -86.847)",
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(53.848 8.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M321.319,136.231a2.879,2.879,0,0,0-2.88,2.88v34.748a2.88,2.88,0,1,0,5.759,0V139.11A2.879,2.879,0,0,0,321.319,136.231Z",
    transform: "translate(-318.439 -136.231)",
    fill: "#fff"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(44.921 12.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M268.53,162.909a2.879,2.879,0,0,0-2.88,2.88v25.724a2.88,2.88,0,1,0,5.759,0V165.789A2.88,2.88,0,0,0,268.53,162.909Z",
    transform: "translate(-265.65 -162.909)",
    fill: "#fff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(71.797 8.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M427.465,136.231a2.879,2.879,0,0,0-2.88,2.88v34.748a2.88,2.88,0,1,0,5.759,0V139.11A2.879,2.879,0,0,0,427.465,136.231Z",
    transform: "translate(-424.585 -136.231)",
    fill: "#fff"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(80.82 16.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M480.822,185.614a2.879,2.879,0,0,0-2.88,2.88v18.045a2.88,2.88,0,1,0,5.759,0V188.494A2.879,2.879,0,0,0,480.822,185.614Z",
    transform: "translate(-477.942 -185.614)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.a3f5f3d5e4c3298e27b7addbec07e48e.svg";
export { ForwardRef as ReactComponent };